// This file will be deleted once all the calculators are configBuilder free
// to be deleted
import React from 'react';

import { iconUri } from '@nerdwallet/nw-client-lib/cdn';
import Icon from '@nerdwallet/react-icon';

const config = {
  title: 'Must reads',
  impressionTrackingName: 'col-related-articles',
  children: [
    {
      imgSrc: iconUri('House_4'),
      title: 'Best Places for Young Families',
      desc: 'Choosing the right mortgage can help make your home buying journey easier and more affordable.​',
      impressionTrackingId: 'col-related-articles-best-places',
      link: {
        href: '/blog/mortgages/how-to-choose-the-best-mortgage?trk_source=mortgages_mc_mustread&trk_content=blog_howtochoosebestmort+pos_topleft&trk_destination=how-to-choose-the-best-mortgage&trk_origin=calculate-mortgage-payment&trk_app=blog',
        children: (
          <div>
            See full article <Icon icon="navigateright" />
          </div>
        ),
      },
    },
    {
      imgSrc: iconUri('Cash_back_3'),
      title: 'Using Cost of Living to Negotiate Your Salary',
      desc: "Before you get the keys to your new home, you'll have to pay closing costs. Once you understand what they cover, they'll look less overwhelming.",
      impressionTrackingId: 'col-related-articles-negotiate',
      link: {
        href: '/blog/mortgages/cost-to-close-mortgage?trk_source=mortgages_mc_mustread&trk_content=blog_costtoclosemort+pos_topright&trk_destination=cost-to-close-mortgage&trk_origin=calculate-mortgage-payment&trk_app=blog',
        children: (
          <div>
            See full article <Icon icon="navigateright" />
          </div>
        ),
      },
    },
    {
      imgSrc: iconUri('Approval'),
      title: 'How to Decide It’s Time to Buy a Home',
      desc: "Mortgage preapproval is the smartest hack to homebuying and among the most misunderstood.​ Here's what lenders want before they'll preapprove you for a home loan.",
      impressionTrackingId: 'col-related-articles-decide',
      link: {
        href: '/blog/mortgages/preapproved-mortgage-matters?trk_source=mortgages_mc_mustread&trk_content=blog_preapprovmortmatters+pos_bottomleft&trk_destination=preapproved-mortgage-matters&trk_origin=calculate-mortgage-payment&trk_app=blog',
        children: (
          <div>
            See full article <Icon icon="navigateright" />
          </div>
        ),
      },
    },
    {
      imgSrc: iconUri('Certificate'),
      title: 'First Time Home Buyer Center',
      desc: "Coming up with the cash for a down payment is the biggest roadblock for most home buyers. Here's how to know how much you really need.",
      impressionTrackingId: 'col-related-articles-home',
      link: {
        href: '/blog/mortgages/payment-buy-home?trk_source=mortgages_mc_mustread&trk_content=blog_pmtbuyhome+pos_bottomright&trk_destination=payment-buy-home&trk_origin=calculate-mortgage-payment&trk_app=blog',
        children: (
          <div>
            See full article <Icon icon="navigateright" />
          </div>
        ),
      },
    },
  ],
};

export default config;
